module.exports = __webpack_public_path__ + "static/media/fomento a la renovacion energetica de viviendas.f185cdc9.jpg";